module.exports = __webpack_public_path__ + "img/arrow.299765b6.svg";